// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3k1M6","label":"Radio_label__2ieVi","checkMark":"Radio_checkMark__2nuDB","disabled":"Radio_disabled__1QaxM"};